// @ts-ignore
import apiService from "./apiService";
import {nextTick} from "vue";
import type {I18n} from "vue-i18n";
import axios from "axios";

export default class TranslationService
{
    static setI18nLanguage(i18n: I18n, locale: string): void {
        if (i18n.mode === 'legacy') {
            i18n.global.locale = locale
        } else {
            // @ts-ignore
            i18n.global.locale.value = locale
        }
        /**
         * NOTE:
         * If you need to specify the language setting for headers, such as the `fetch` API, set it here.
         * The following is an example for axios.
         *
         * axios.defaults.headers.common['Accept-Language'] = locale
         */
        // @ts-ignore
        document.querySelector('html').setAttribute('lang', locale);
    }

    static async loadTranslations(i18n: I18n, callback: any) {
        await axios.get(apiService.translationsEndpoint())
            .then((response) => {
                const translations = response.data.translations;
                const default_locale = response.data.default_locale;
                for (const locale in translations) {
                    if (! translations.hasOwnProperty(locale)) {
                        continue;
                    }
                    const items = translations[locale];

                    i18n.global.setLocaleMessage(locale, items);
                }
                callback(default_locale);
            });

        return nextTick();
    }
}